export const ACTION_AUTHORITY_AUTHOR_EXPORT = 'aa_export';
export const ACTION_AUTHORITY_PUBLISHER_EXPORT = 'ap_export';
export const ACTION_BOOK_EXPORT = 'book_export';
export const ACTION_BOOK_IMPORT = 'book_import';
export const ACTION_CREATE_REQUEST_BY_ORDERS = 'action_create_request_by_orders';
export const ACTION_EBOOK_BANK_IMPORT = 'ebook_bank_import';
export const ACTION_EBOOK_PAYMENT_IMPORT = 'ebook_payment_import';
export const ACTION_EBOOK_PAYMENT_DOWNLOAD = 'ebook_payment_download';
export const ACTION_EBOOK_REPORT_EXPORT = 'ebook_report_export';
export const ACTION_EBOOK_REPORT_IMPORT = 'ebook_report_import';
export const ACTION_EBOOK_SUPPLIER_EXPORT = 'ebookswl/export';
export const ACTION_EBOOK_SUPPLIER_UPLOAD = 'ebookswl/ebook_supplier_send_wl';
export const ACTION_CLASSIFIER_IMPORT = 'classifier_import';
export const ACTION_INSTANCE_CHANGE_OWNER = 'instance_changeowner';
export const ACTION_INSTANCE_DELETE = 'instance_delete';
export const ACTION_INSTANCE_MERGE = 'merge_instances';
export const ACTION_INSTANCE_UPDATE_FIELDS = 'update_fields';
export const ACTION_MREPORT_IMPORT = 'mreport_import';
export const ACTION_ONIX_EXPORT = 'onix_export';
export const ACTION_ONIX_IMPORT = 'onix_import';
export const ACTION_ONIX_IMPORT_LOCAL = 'onix_import_local';
export const ACTION_ONIX_IMPORT_ELIBRI = 'onix_import_elibri';
export const ACTION_ORDER_CREATE_BY_OFFER = 'action_create_order_by_offer';
export const ACTION_ORDERS_CREATE_BY_OFFERS = 'action_create_orders_by_offers';
export const ACTION_PROCUREMENT_CREATE_BY_OFFER = 'action_create_procurement_by_offer';
export const ACTION_PRODUCT_BORROW_BOOK = 'borrow_book';
export const ACTION_PRODUCT_EXPORT = 'product_export';
export const ACTION_PROVIDER_IMPORT = 'provider_import';
export const ACTION_USH_EXPORT = 'ush_xml_export';
export const ACTION_USH_IMPORT = 'ush_import';
export const ACTION_ELIBRI_API = 'elibri_api';

export const ACC_MREPORT = 'acc_mreport';

export const ACCESS_VIEW_MASTER_FIELDS = 'acc_master_fields';
export const ACCESS_FAST_FILTER_MASTER_FIELDS = 'acc_fast_master_fields';
export const ACCESS_HARD_FILTER_MASTER_FIELDS = 'acc_hard_master_fields';
export const ACCESS_COMMUNICATION_INFO = 'communication_info_acc';
export const ACCESS_VIEW_ALL_OWNER_OBJECT = 'acc_all_owner_object';
export const ACCESS_VIEW_BOOKSHOP_AREA = 'acc_bookshop_area';
export const ACCESS_EREPORT_ITEM = "acc_ereport_item";
